export default "__VITE_ASSET__6pgMNPNa__"